var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"error text-center"},[_c('i',{staticClass:"fa icon",class:[ _vm.e.icon ]}),_vm._v(" "),_c('h2',{staticClass:"h3 font-weight-bold"},[_vm._v(_vm._s(_vm.e.title))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.e.message))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }